import React from "react";

import {
  NavLink,
  useLocation,
  useNavigate
} from "react-router-dom";

import logo from "../assets/logo.png";

export default function Sidebar() {

  const location = useLocation();

  const navigate = useNavigate();

  const onLogoutClick = () => {

    // PROFILE PAGE
    // show popup
    if (location.pathname === "/profile") {

      window.dispatchEvent(
        new Event("app-logout")
      );

      return;
    }

    // OTHER PAGES
    // direct logout
    localStorage.removeItem("user");

    localStorage.removeItem("token");

    navigate("/");
  };

  return (

    <div className="sidebar">

      <div className="logo-container">

        <img
          src={logo}
          alt="Logo"
          className="logo-img"
        />

        <div className="logo-text">
          RDS HelpDesk
        </div>

      </div>

      <nav className="menu">

        <NavLink
          to="/userdashboard"
          className={({ isActive }) =>
            isActive
              ? "menu-link active-left"
              : "menu-link"
          }
        >
          Dashboard
        </NavLink>

        <NavLink
          to="/create-ticket"
          className={({ isActive }) =>
            isActive
              ? "menu-link active-left"
              : "menu-link"
          }
        >
          Create Ticket
        </NavLink>

        <NavLink
          to="/my-tickets"
          className={({ isActive }) =>
            isActive
              ? "menu-link active-left"
              : "menu-link"
          }
        >
          My Tickets
        </NavLink>

  

        <NavLink
          to="/profile"
          className={({ isActive }) =>
            isActive
              ? "menu-link active-left"
              : "menu-link"
          }
        >
          Profile
        </NavLink>

        <div
          onClick={onLogoutClick}
          className="menu-link"
        >
          Logout
        </div>

      </nav>

    </div>
  );
}